import { render, staticRenderFns } from "./contract-detail-ecommerce-nganluong.vue?vue&type=template&id=876b4104&scoped=true"
import script from "./contract-detail-ecommerce-nganluong.vue?vue&type=script&lang=js"
export * from "./contract-detail-ecommerce-nganluong.vue?vue&type=script&lang=js"
import style0 from "./contract-detail-ecommerce-nganluong.vue?vue&type=style&index=0&id=876b4104&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "876b4104",
  null
  
)

export default component.exports